import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getFFSeaExpConsigneeBranch, getFFSeaExpConsigneeBranchBank, getFFSeaExpOrganisationBranch, getFFSeaExpShipperBranch, getFFSeaExpShipperBranchBank, getFFSECity, getFFSECountry, getFFSESeaport, getFFSEState, getPackageInfoByQuotation } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaExpAction';
import { customStyles } from '../../../../../../../HelperFunctions';
import { adminMainUrl } from '../../../../../../../Config';
import {
    applyNoOfCopiesValidation,
    handleNoOfCopiesInputChange,
    handleTypeOfBlSelectChange,
} from './ffBlCopiesFieldUtils';

const ConsoleShipmentSEHBLAdd = ({
    trans_mode,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    joborderffdetails
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Options for "Type of BL" dropdown
    const blTypeOptions = [
        { value: 'Original BL', label: 'Original BL' },
        { value: 'Seaway BL', label: 'Seaway BL' },
    ];

    // Options for "Seal Type" dropdown
    const sealTypeOptions = [
        { value: 'Shipper', label: 'Shipper' },
        { value: 'Customer', label: 'Customer' },
        { value: 'Bolt', label: 'Bolt' },
    ];

    // ---- State for Add Row Modal ----
    const [showAddRowModal, setShowAddRowModal] = useState(false);
    const [newRowData, setNewRowData] = useState({
        container_number: '',
        line_seal_no: '',
        seal_type: '',
        seal_number: '',
        invoice_no: '',
        no_of_package: '',
        goods_description: '',
        gross_weight: '',
        gross_weight_unit: 'Kg',
        volume: '',
        volume_unit: 'CBM',
    });

    // Refs to prevent duplicate prefills
    const lastJobOrderId = useRef(null);
    const hasFilledCargoRows = useRef(false);

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSECountry(token, user_id));
            dispatch(getFFSESeaport(token, user_id));
        }
    }, []);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    let [countryOptions, setCountryOptions] = useState([]);
    let [stateOptions, setStateOptions] = useState([]);
    let [cityOptions, setCityOptions] = useState([]);
    let [seaportOptions, setSeaportOptions] = useState([]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);

    useEffect(() => {
        if (token && user_id && quotation_id) {
            dispatch(getPackageInfoByQuotation(token, user_id, quotation_id))
        }
    }, [quotation_id]);

    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFSeaExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaExpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFSeaExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };

    const {
        loadingFFSeaExpShipperBranchList,
        FFSeaExpShipperBranchList,
        FFSeaExpShipperBranchListError,
        loadingFFSeaExpConsigneeBranchList,
        FFSeaExpConsigneeBranchList,
        FFSeaExpConsigneeBranchListError,
        loadingFFSeaExpShipperBranchBankList,
        FFSeaExpShipperBranchBankList,
        FFSeaExpShipperBranchBankListError,
        loadingFFSeaExpConsigneeBranchBankList,
        FFSeaExpConsigneeBranchBankList,
        FFSeaExpConsigneeBranchBankListError,
        loadingFFQueryDetail,
        FFQueryDetail,
        FFQueryDetailError,
        loadingFFSECountry,
        FFSECountry,
        FFSECountryError,
        loadingFFSEState,
        FFSEState,
        FFSEStateError,
        loadingFFSECity,
        FFSECity,
        FFSECityError,
        loadingFFSESeaport,
        FFSESeaport,
        FFSESeaportError,
    } = useSelector(state => state.FFSeaExpReducer);

    useEffect(() => {
        if (FFSECountry) {
            let arr = [];
            FFSECountry.map(val => arr.push({ value: val.id, label: val.name }));
            setCountryOptions(arr);
        }
    }, [loadingFFSECountry, FFSECountry])

    useEffect(() => {
        if (FFSEState) {
            let arr = [];
            FFSEState.map(val => arr.push({ value: val.id, label: val.name }));
            setStateOptions(arr);
        }
    }, [loadingFFSEState, FFSEState]);

    useEffect(() => {
        if (FFSECity) {
            let arr = [];
            FFSECity.map(val => arr.push({ value: val.id, label: val.name }));
            setCityOptions(arr);
        }
    }, [loadingFFSECity, FFSECity])
    useEffect(() => {
        if (FFSESeaport) {
            let arr = [];
            FFSESeaport.map(val => arr.push({ value: val.id, label: val.name }));
            setSeaportOptions(arr);
        }
    }, [loadingFFSESeaport, FFSESeaport])

    useEffect(() => {
        if (FFSeaExpShipperBranchList) {
            let arr = [];
            FFSeaExpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFSeaExpShipperBranchList]);

    useEffect(() => {
        if (FFSeaExpShipperBranchBankList) {
            let arr = [];
            FFSeaExpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFSeaExpShipperBranchBankList]);

    useEffect(() => {
        if (FFSeaExpConsigneeBranchList) {
            let arr = [];
            FFSeaExpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFSeaExpConsigneeBranchList]);

    useEffect(() => {
        if (FFSeaExpConsigneeBranchBankList) {
            let arr = [];
            FFSeaExpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFSeaExpConsigneeBranchBankList]);

    // Define the default row object with empty strings (no default "0")
    let row_object_arr = [
        {
            no_of_package: "",
            goods_description: "",
            gross_weight: "",
            gross_weight_unit: "",
            measurement: "",
            invoice_no: "",
            sb_no: "",
            sb_date: "",
            net_weight: "",
            net_weight_unit: "",
            container_number: "",
            line_seal_no: "",
            seal_type: "",
            volume: "",
            volume_unit: "",
        }
    ];

    const initialValues = {
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: 0,
        shipper_branch_id: 0,
        shipper_branch_address_id: 0,
        consignee_id: 0,
        consignee_branch_id: 0,
        consignee_branch_address_id: 0,
        notify_address: "",
        notify_email_address: "",
        place_of_acceptance: "",
        port_of_loading: "",
        port_of_discharge: "",
        place_of_delivery: "",
        vessel_and_voyage_no: "",
        product_description_json: "",
        freight_term: "",
        freight_payable_at: "",
        number_of_original_mdt: "",
        place_of_issue: "",
        place_of_date: "",
        other_particular_address: "",
        other_particular_country: "",
        other_particular_city: "",
        other_particular_state: "",
        other_particular_zipcode: "",
        other_particular_name: "",
        shipped_on_board_date: "",
        delivery_of_goods_apply_to_name: "",
        delivery_of_goods_apply_to_address: "",
        delivery_of_goods_apply_to_email: "",
        delivery_of_goods_apply_to_tax_id: "",
        delivery_of_goods_apply_to_zc: "",
        is_sli_recived: "",
        shipping_line: "",
        type_of_bl: "",
        no_of_copies: "",
        rows: [
            {
                no_of_package: "",
                goods_description: "",
                gross_weight: "",
                gross_weight_unit: "",
                measurement: "",
                invoice_no: "",
                sb_no: "",
                sb_date: "",
                net_weight: "",
                net_weight_unit: "",
                container_number: "",
                line_seal_no: "",
                seal_type: "",
                volume: "",
                volume_unit: "",
            }
        ]
    }

    const formik = useFormik({
        initialValues: initialValues,
        validate: (values) => {
            const errors = {};
            if (values.notify_email_address && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.notify_email_address)) {
                errors.notify_email_address = 'Invalid email address';
            }
            if (values.delivery_of_goods_apply_to_email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.delivery_of_goods_apply_to_email)) {
                errors.delivery_of_goods_apply_to_email = 'Invalid email address';
            }

            applyNoOfCopiesValidation(values, errors);

            if (values.rows && values.rows.length > 0) {
                const rowsErrors = [];
                let hasRowErrors = false;
                values.rows.forEach((row, index) => {
                    const rowErrors = {};
                    if (row.container_number) {
                        if (!/^[A-Z]{4}\d{7}$/.test(row.container_number)) {
                            rowErrors.container_number = 'Invalid Container Number Format. Container Number must contain 4 alphabets followed by 7 numeric digits';
                            hasRowErrors = true;
                        }
                    }
                    rowsErrors[index] = rowErrors;
                });
                if (hasRowErrors) {
                    errors.rows = rowsErrors;
                }
            }

            return errors;
        },
        onSubmit: (values, { resetForm }) => {
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;
            values.product_description_json = values.rows
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/sea/export/hbl/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            setCountryOptions([]);
                            setStateOptions([]);
                            setCityOptions([]);
                            setSeaportOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/export/console/hbl`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (formik.values.other_particular_country) {
            dispatch(getFFSEState(token, user_id, formik.values.other_particular_country));
        }
    }, [formik.values.other_particular_country])
    useEffect(() => {
        if (formik.values.other_particular_state) {
            dispatch(getFFSECity(token, user_id, formik.values.other_particular_state));
        }
    }, [formik.values.other_particular_state])

    // ---- This effect does NOT populate rows from quotation or cargo details ----
    useEffect(() => {
        // Intentionally left empty – rows are not pre-filled.
    }, [FFQueryDetail]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_chapkgrge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);

    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/hbl/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob'
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };

    // ---- PREFILL LOGIC (only for non‑row fields; rows are NOT pre‑filled) ----
    useEffect(() => {
        if (!joborderffdetails) return;

        let freight = null;

        if (joborderffdetails.freight && joborderffdetails.freight.shipper_id !== undefined) {
            freight = joborderffdetails.freight;
        } else if (joborderffdetails.freightDetails && joborderffdetails.freightDetails.shipper_id !== undefined) {
            freight = joborderffdetails.freightDetails;
        } else if (joborderffdetails.jobOrderFreigthDetails && joborderffdetails.jobOrderFreigthDetails.shipper_id !== undefined) {
            freight = joborderffdetails.jobOrderFreigthDetails;
        } else if (joborderffdetails.shipper_id !== undefined) {
            freight = joborderffdetails;
        }

        if (!freight) {
            console.warn("ConsoleShipmentSEHBLAdd: No freight object found", joborderffdetails);
            return;
        }

        if (lastJobOrderId.current === freight.job_order_id) {
            return;
        }

        lastJobOrderId.current = freight.job_order_id;

        formik.setFieldValue("shipper_id", freight.shipper_id || 0);
        formik.setFieldValue("shipper_branch_id", freight.shipper_branch_id || 0);
        formik.setFieldValue("shipper_branch_bank_account_id", freight.shipper_branch_bank_account_id || 0);
        formik.setFieldValue("consignee_id", freight.consignee_id || 0);
        formik.setFieldValue("consignee_branch_id", freight.consignee_branch_id || 0);
        formik.setFieldValue("consignee_branch_bank_account_id", freight.consignee_branch_bank_account_id || 0);
        formik.setFieldValue("port_of_loading", freight.port_of_loading || 0);
        formik.setFieldValue("port_of_discharge", freight.port_of_discharge || 0);
        formik.setFieldValue("place_of_acceptance", freight.place_of_acceptance || "");
        formik.setFieldValue("place_of_delivery", freight.place_of_delivery || "");
        formik.setFieldValue("vessel_and_voyage_no", freight.vessel_and_voyage_no || "");
        formik.setFieldValue("freight_term", freight.freight_term || "");
        formik.setFieldValue("freight_payable_at", freight.freight_payable_at || "");
        formik.setFieldValue("number_of_original_mdt", freight.number_of_original_mdt || "");
        formik.setFieldValue("place_of_issue", freight.place_of_issue || "");
        formik.setFieldValue("place_of_date", freight.place_of_date || "");
        formik.setFieldValue("notify_address", freight.notify_address || "");
        formik.setFieldValue("notify_email_address", freight.notify_email_address || "");
        formik.setFieldValue("delivery_of_goods_apply_to_address", freight.delivery_of_goods_apply_to_address || "");
        formik.setFieldValue("delivery_of_goods_apply_to_email", freight.delivery_of_goods_apply_to_email || "");
        formik.setFieldValue("delivery_of_goods_apply_to_tax_id", freight.delivery_of_goods_apply_to_tax_id || "");
        formik.setFieldValue("delivery_of_goods_apply_to_zc", freight.delivery_of_goods_apply_to_zc || "");
        formik.setFieldValue("delivery_of_goods_apply_to_name", freight.delivery_of_goods_apply_to_name || freight.name || "");
        formik.setFieldValue("other_particular_name", freight.other_particular_name || freight.name || "");
        formik.setFieldValue("shipping_line", freight.shipping_line || "");
        formik.setFieldValue("type_of_bl", freight.type_of_bl || "");
        formik.setFieldValue("no_of_copies", freight.no_of_copies || "");

        if (freight.shipper_id) {
            handleShipperBranch(freight.shipper_id);
        }
        if (freight.consignee_id) {
            handleConsigneeBranch(freight.consignee_id);
        }

        if (joborderffdetails.cargoGoodDetails && joborderffdetails.cargoGoodDetails.length > 0) {
            const mappedRows = joborderffdetails.cargoGoodDetails.map(cargo => ({
                container_number: "",
                line_seal_no: "",
                seal_type: "",
                invoice_no: "",
                no_of_package: cargo.marks_and_nos || cargo.packages_count || "",
                goods_description: cargo.description || "",
                gross_weight: cargo.gross_weight || "",
                gross_weight_unit: cargo.gross_weight_type || "Kg",
                measurement: "",
                sb_no: "",
                sb_date: "",
                net_weight: cargo.net_weight || "",
                net_weight_unit: "",
                volume: cargo.total_volume || "",
                volume_unit: cargo.volume_type || "CBM",
            }));
            formik.setFieldValue("rows", mappedRows);
        }
        console.log("✅ ConsoleShipmentSEHBLAdd - Prefilled freight:", freight);
    }, [joborderffdetails]);

    // ---- Handler for adding a new row via modal ----
    const handleAddRowFromModal = () => {
        const lastIndex = formik.values.rows.length - 1;
        const lastRow = formik.values.rows[lastIndex];

        // Always update the last row with modal data (merge)
        const updatedRows = [...formik.values.rows];
        updatedRows[lastIndex] = {
            ...lastRow,
            container_number: newRowData.container_number || lastRow.container_number,
            line_seal_no: newRowData.line_seal_no || lastRow.line_seal_no,
            seal_type: newRowData.seal_type || lastRow.seal_type,
            seal_number: newRowData.seal_number || lastRow.seal_number,
            invoice_no: newRowData.invoice_no || lastRow.invoice_no,
            no_of_package: newRowData.no_of_package || lastRow.no_of_package,
            goods_description: newRowData.goods_description || lastRow.goods_description,
            gross_weight: newRowData.gross_weight || lastRow.gross_weight,
            gross_weight_unit: newRowData.gross_weight_unit || lastRow.gross_weight_unit,
            volume: newRowData.volume || lastRow.volume,
            volume_unit: newRowData.volume_unit || lastRow.volume_unit,
        };

        formik.setFieldValue("rows", updatedRows);
        setNewRowData({
            container_number: '',
            line_seal_no: '',
            seal_type: '',
            seal_number: '',
            invoice_no: '',
            no_of_package: '',
            goods_description: '',
            gross_weight: '',
            gross_weight_unit: 'Kg',
            volume: '',
            volume_unit: 'CBM',
        });
        setShowAddRowModal(false);
    };

    // ---- Determine if Seal Number column should be shown ----
    const showSealNumberColumn = formik.values.rows.some(row => row.seal_type && row.seal_type !== '');

    // ---- Determine if Cargo Data columns should be shown (Marks, Cargo Description, Gross Weight, Volume) ----
    const hasCargoData = formik.values.rows.some(row =>
        row.no_of_package || row.goods_description || row.gross_weight || row.volume
    );

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>HBL</h3>
                    <div className="col-md-12">
                        <div className="row subheading-strip">
                            <div className="col-md-12">
                                <h4 className='mt-2'>Party Details</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {
                        formik.values.is_sli_recived === 'Yes' && (
                            <>
                                <div className="col-md-6 mt-2 d-flex align-items-center justify-content-end">
                                    <div className="row d-flex justify-content-end">
                                        <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>
                                        <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_SE_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        setShipperBranchOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFSeaExpShipperBranchList}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFSeaExpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Notify Address
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <textarea
                                    className='form-control'
                                    id="notify_address"
                                    name="notify_address"
                                    value={formik.values.notify_address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                         <InputTextJSX labelText={"Notify Email"} nameValue={"notify_email_address"} value={formik.values.notify_email_address} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.notify_email_address && formik.errors.notify_email_address ? formik.errors.notify_email_address : ''} maxLength={100} />
                    </div>
                    <div className="col-md-3 mt-2">
                            <InputTextJSX labelText={"Place of acceptance"} nameValue={"place_of_acceptance"} value={formik.values.place_of_acceptance} onChange={formik.handleChange} maxLength={250} />
                    </div>
                   
                

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Loading
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_loading"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_loading', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_loading || null)}
                                    isLoading={loadingFFSeaExpConsigneeBranchBankList}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Discharge
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_discharge"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_discharge', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_discharge || null)}
                                    isLoading={loadingFFSeaExpConsigneeBranchBankList}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                         <InputTextJSX labelText={"Place of delivery"} nameValue={"place_of_delivery"} value={formik.values.place_of_delivery} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Vessel & Voyage No."} nameValue={"vessel_and_voyage_no"} value={formik.values.vessel_and_voyage_no} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    <div className="col-md-3 mt-2">
                            <InputTextJSX labelText={"Shipping Line"} nameValue={"shipping_line"} value={formik.values.shipping_line} onChange={formik.handleChange} maxLength={100} />
                    </div>
                    <div className="col-md-3 mt-2">
                        <SelectReactJSX
                        labelText={"Freight Term"}
                        nameValue={"freight_term"}
                        options={[
                            { value: 'Prepaid', label: 'Prepaid' },
                            { value: 'Collect', label: 'Collect' }
                        ]}
                        onChange={(option) => formik.setFieldValue("freight_term", option ? option.value : "")}
                        value={[
                            { value: 'Prepaid', label: 'Prepaid' },
                            { value: 'Collect', label: 'Collect' }
                        ].find(opt => opt.value === formik.values.freight_term) || null}
                    />
                    </div>
                    <div className="col-md-3 mt-2">
                        <InputTextJSX labelText={"Freight Payable At"} nameValue={"freight_payable_at"} value={formik.values.freight_payable_at} onChange={formik.handleChange} maxLength={250} />
                    </div>
                   
                    
                
                    
                    

                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label mb-0'>
                                Type of BL
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={blTypeOptions}
                                    styles={customStyles}
                                    name="type_of_bl"
                                    onChange={option => handleTypeOfBlSelectChange(option, formik)}
                                    isClearable
                                    value={blTypeOptions.find(option => option.value === formik.values.type_of_bl) || null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                No. of copies
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={2}
                                    className="form-control form-control-sm"
                                    id="no_of_copies"
                                    name="no_of_copies"
                                    value={formik.values.no_of_copies}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => handleNoOfCopiesInputChange(e, formik)}
                                    disabled={!formik.values.type_of_bl}
                                />
                                {formik.errors.no_of_copies && formik.touched.no_of_copies && (
                                    <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                        {formik.errors.no_of_copies}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
<div className={`col-md-3 mt-2`}>
         <InputTextJSX labelText={"Place of issue"} nameValue={"place_of_issue"} value={formik.values.place_of_issue} onChange={formik.handleChange} maxLength={250} />
</div>
               
                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Date of Issue
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="place_of_date"
                                    name="place_of_date"
                                    value={formik.values.place_of_date}
                                    onChange={formik.handleChange}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                            </div>
                        </div>
                    </div>

                    <h4 className='mt-2 subheading-strip'>For delivery of goods please apply to:</h4>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Name"} nameValue={"delivery_of_goods_apply_to_name"} value={formik.values.delivery_of_goods_apply_to_name} onChange={formik.handleChange} maxLength={100} />
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Address"} nameValue={"delivery_of_goods_apply_to_address"} value={formik.values.delivery_of_goods_apply_to_address} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Email"} nameValue={"delivery_of_goods_apply_to_email"} value={formik.values.delivery_of_goods_apply_to_email} onChange={formik.handleChange} maxlength={60} />
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Tax ID"} nameValue={"delivery_of_goods_apply_to_tax_id"} value={formik.values.delivery_of_goods_apply_to_tax_id} onChange={formik.handleChange} maxlength={20} />
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"ZC"} nameValue={"delivery_of_goods_apply_to_zc"} value={formik.values.delivery_of_goods_apply_to_zc} onChange={formik.handleChange} maxlength={10} />
                    </div>
                    
                    
                    
                    
                    

                    <h4 className='mt-2 subheading-strip'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Container No.(s)</th>
                                    <th scope="col">Line Seal No.*</th>
                                    <th scope="col">Seal Type</th>
                                    {showSealNumberColumn && <th scope="col">Seal Number</th>}
                                    <th scope="col">Invoice Number</th>
                                    {hasCargoData && <th scope="col">Marks & Number</th>}
                                    {hasCargoData && <th scope="col">Cargo Description</th>}
                                    {hasCargoData && <th scope="col">Gross Cargo Weight</th>}
                                    {hasCargoData && <th scope="col">Volume</th>}
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].container_number`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                maxLength={100}
                                                value={row.container_number}
                                                pattern="[A-Z]{4}[0-9]{7}"
                                                title="Container number must be 4 uppercase letters followed by 7 digits (e.g., ABCD1234567)"
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                                    if (value.length > 11) value = value.slice(0, 11);
                                                    event.target.value = value;
                                                    formik.handleChange(event);
                                                }}
                                            />
                                            {formik.errors.rows?.[index]?.container_number && formik.touched.rows?.[index]?.container_number && (
                                                <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                                    {formik.errors.rows[index].container_number}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].line_seal_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.line_seal_no}
                                                maxLength={50}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].seal_type`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.seal_type}
                                            >
                                                <option value="">-</option>
                                                {sealTypeOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        {showSealNumberColumn && (
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].seal_number`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.seal_number}
                                                    maxLength={50}
                                                    placeholder="Enter seal number"
                                                />
                                            </td>
                                        )}
                                        <td>
                                            <input
                                                type="text"
                                                maxLength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].invoice_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.invoice_no}
                                            />
                                        </td>
                                        {hasCargoData && (
                                            <td>
                                                <input
                                                    type="text"
                                                    maxLength={50}
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].no_of_package`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.no_of_package}
                                                />
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].goods_description`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.goods_description}
                                                    maxLength={250}
                                                />
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <div className="d-flex align-items-center gap-1" style={{ minWidth: '120px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '65%' }}
                                                        name={`rows[${index}].gross_weight`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.gross_weight}
                                                        maxLength={10}
                                                        placeholder="Weight"
                                                        onInput={(event) => {
                                                            let value = event.target.value;
                                                            value = value.replace(/[^0-9.]/g, '');
                                                            const parts = value.split('.');
                                                            if (parts.length > 2) {
                                                                value = parts[0] + '.' + parts[1];
                                                            }
                                                            if (parts[1] && parts[1].length > 2) {
                                                                value = parts[0] + '.' + parts[1].substring(0, 2);
                                                            }
                                                            event.target.value = value;
                                                        }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '35%' }}
                                                        name={`rows[${index}].gross_weight_unit`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.gross_weight_unit}
                                                        placeholder="Unit"
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <div className="d-flex align-items-center gap-1" style={{ minWidth: '120px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '65%' }}
                                                        name={`rows[${index}].volume`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.volume}
                                                        maxLength={10}
                                                        placeholder="Volume"
                                                        onInput={(event) => {
                                                            let value = event.target.value;
                                                            value = value.replace(/[^0-9.]/g, '');
                                                            const parts = value.split('.');
                                                            if (parts.length > 2) {
                                                                value = parts[0] + '.' + parts[1];
                                                            }
                                                            if (parts[1] && parts[1].length > 2) {
                                                                value = parts[0] + '.' + parts[1].substring(0, 2);
                                                            }
                                                            event.target.value = value;
                                                        }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '35%' }}
                                                        name={`rows[${index}].volume_unit`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.volume_unit}
                                                        placeholder="Unit"
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove row'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => setShowAddRowModal(true)}
                                                >
                                                    Add More
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Ship On Board Date:
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="shipped_on_board_date"
                                    name="shipped_on_board_date"
                                    value={formik.values.shipped_on_board_date}
                                    onChange={formik.handleChange}
                                    min={new Date().toISOString().split('T')[0]}
                                    disabled={!formik.values.type_of_bl}
                                />
                            </div>
                        </div>
                    </div>

                    <h4 className='mt-2 subheading-strip'>Other Particulars</h4>
                    <div className={`col-md-3 mt-2`}>
                        <InputTextJSX labelText={"Name"} nameValue={"other_particular_name"} value={formik.values.other_particular_name} onChange={formik.handleChange} maxLength={100} />
                    </div>
                    <div className={`col-md-3 mt-2`}>
                           <InputTextJSX labelText={"Address"} nameValue={"other_particular_address"} value={formik.values.other_particular_address} onChange={formik.handleChange} maxLength={250} />
                    </div>
                    
                 
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Country
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={countryOptions}
                                    styles={customStyles}
                                    name="other_particular_country"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_country', option.value);
                                    }}
                                    value={countryOptions.find(option => option.value == formik.values.other_particular_country || null)}
                                    isLoading={loadingFFSECountry}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                State
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={stateOptions}
                                    styles={customStyles}
                                    name="other_particular_state"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_state', option.value);
                                    }}
                                    value={stateOptions.find(option => option.value == formik.values.other_particular_state || null)}
                                    isLoading={loadingFFSEState}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                City
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={cityOptions}
                                    styles={customStyles}
                                    name="other_particular_city"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_city', option.value);
                                    }}
                                    value={cityOptions.find(option => option.value == formik.values.other_particular_city || null)}
                                    isLoading={loadingFFSECity}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`col-md-3 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Zip Code
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={6}
                                    className="form-control form-control-sm"
                                    id={"other_particular_zipcode"}
                                    name={"other_particular_zipcode"}
                                    value={formik.values.other_particular_zipcode}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                        </button>
                    </div>
                </div>
            </form>

            {/* ── Add Row Modal ── */}
            <Modal show={showAddRowModal} onHide={() => setShowAddRowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Rate Description Row</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Marks & Number</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={newRowData.no_of_package}
                                onChange={(e) => setNewRowData({ ...newRowData, no_of_package: e.target.value })}
                                maxLength={50}
                            />
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Cargo Description</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={newRowData.goods_description}
                                onChange={(e) => setNewRowData({ ...newRowData, goods_description: e.target.value })}
                                maxLength={250}
                            />
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Gross Cargo Weight</label>
                            <div className="d-flex gap-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 2 }}
                                    value={newRowData.gross_weight}
                                    onChange={(e) => setNewRowData({ ...newRowData, gross_weight: e.target.value })}
                                    placeholder="Weight"
                                    maxLength={10}
                                    onInput={(e) => {
                                        let val = e.target.value.replace(/[^0-9.]/g, '');
                                        const parts = val.split('.');
                                        if (parts.length > 2) val = parts[0] + '.' + parts[1];
                                        if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
                                        e.target.value = val;
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 1 }}
                                    value={newRowData.gross_weight_unit}
                                    onChange={(e) => setNewRowData({ ...newRowData, gross_weight_unit: e.target.value })}
                                    placeholder="Unit"
                                />
                            </div>
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Volume</label>
                            <div className="d-flex gap-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 2 }}
                                    value={newRowData.volume}
                                    onChange={(e) => setNewRowData({ ...newRowData, volume: e.target.value })}
                                    placeholder="Volume"
                                    maxLength={10}
                                    onInput={(e) => {
                                        let val = e.target.value.replace(/[^0-9.]/g, '');
                                        const parts = val.split('.');
                                        if (parts.length > 2) val = parts[0] + '.' + parts[1];
                                        if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
                                        e.target.value = val;
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 1 }}
                                    value={newRowData.volume_unit}
                                    onChange={(e) => setNewRowData({ ...newRowData, volume_unit: e.target.value })}
                                    placeholder="Unit"
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-secondary" onClick={() => setShowAddRowModal(false)}>
                        Cancel
                    </button>
                    <button className="btn btn-sm btn-primary" onClick={handleAddRowFromModal}>
                        Add Row
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ConsoleShipmentSEHBLAdd